
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M25 14.995a2 2 0 00-2-2h-7a2 2 0 00-2 2v7a2 2 0 002 2h7a2 2 0 002-2v-7zm-9 0h7v7h-7v-7zM23.971 11.005h-9a1 1 0 01-.786-1.618l4.282-5.454V1.972a1 1 0 01.257-1.967H20.217a1 1 0 01.258 1.966v1.962l4.283 5.454a1 1 0 01-.787 1.618zm-4.5-5.112l-2.443 3.112h4.887L19.47 5.893zM.474 10.855a1 1 0 01-.474-.85v-9A1 1 0 011.447.11l9 4.5a1 1 0 010 1.79l-9 4.5a1 1 0 01-.973-.045zm7.29-5.35L2 2.623v5.764l5.764-2.882z","fill":"#AFB0BF"}}),_c('path',{attrs:{"d":"M0 14.476c0-.53.43-.961.961-.961h.078a.961.961 0 110 1.922H.96a.961.961 0 01-.961-.96zM0 18.495c0-.53.43-.961.961-.961h.078a.961.961 0 010 1.922H.96a.961.961 0 01-.961-.96zM0 22.515c0-.531.43-.962.961-.962h.078a.961.961 0 110 1.923H.96A.961.961 0 010 22.515z","fill":"#AFB0BF"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3 14.524a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1zM3 18.44a1 1 0 011-1h3a1 1 0 110 2H4a1 1 0 01-1-1zM3 22.514a1 1 0 011-1h3a1 1 0 110 2H4a1 1 0 01-1-1z","fill":"#AFB0BF"}})])
          )
        }
      }
    